import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseFormKitComponent } from '@pishgamrayan/ng-form-kit';
import { ReplaySubject } from 'rxjs';

@Component({
    template: ``,
    standalone: false
})
export class BaseSelectSearchProperties extends BaseFormKitComponent {
  @Input() optimalSearch: boolean = false;
  @Input() isDefaultValue: boolean = false;
  @Input() initLoading: boolean = false;
  @Input() isFetchData: boolean = false;
  @Input() removable: boolean = true;
  @Input() isShowRefreshBtn: boolean = false;
  @Input() isDeleteAfterEmit: boolean = false;

  @Input() items: any[];
  @Input() updateItems: number;
  @Input() optionTitle: string;
  @Input() optionValue: string | number;
  @Input() fieldNameToSearch: string;

  @Input() item: any;
  @Output() itemChange = new EventEmitter<any>();

  @Output() onError = new EventEmitter<boolean>();
  @Output() onRefresh = new EventEmitter<any>();

  filterControl: FormControl = new FormControl();
  filteredItems: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
}
